import React, {useEffect, useContext, useState} from 'react'
import ControlButtonAdd from '../components/ControlButtonAdd';
import ModalProfileUpdate from '../components/ModalProfileUpdate';
import PageHeader from '../components/PageHeader';
import useDocumentTitle from '../components/useDocumentTitle';

import MyAuthContext from '../context/AuthContext'

import SuccessAlert from '../components/SuccessAlert';

const Profile = () => {
    const style = {
        profileTitle: "text-right",
        textDiv: "w-full sm:w-[60%] mx-auto",
        profileText: "font-light border-b-2 border-gray-200 text-center"
    }
    const documentTypes = ["Cedula de ciudadania", "Cedula de extranjeria", "Pasaporte"];

    useDocumentTitle("Mi Perfil")
    const { getUser, user } = useContext(MyAuthContext);
    const [isModalProfileUpdateOpen, setIsModalProfileUpdateOpen] = useState(false);
    const [successAlert, setSuccessAlert] = useState(null);

    useEffect(() => {
        getUser();
    }, [])  

    return (
        <>
            <PageHeader tittle="MI PERFIL" />
            <ModalProfileUpdate isModalProfileUpdateOpen={isModalProfileUpdateOpen} setIsModalProfileUpdateOpen={setIsModalProfileUpdateOpen} setSuccessAlert={setSuccessAlert} />
            <SuccessAlert isVisible={successAlert} />
            <div className='flex md:px-5 px-1'>
                <div className='my-6 rounded rounded-lg flex flex-col w-[95%] sm:w-[70%] p-6 bg-white mx-auto '>
                    <h1 className='text-center w-full text-2xl mb-4'>DATOS DE LA CUENTA</h1>
                    <div className='grid gap-x-4 gap-y-6 grid-cols-[25%,75%] '>
                        <div className={style.profileTitle}>
                            Nombre(s):
                        </div>
                        <div className={style.textDiv}>
                            <p className={style.profileText}>{user.userName}</p>
                        </div>

                        <div className={style.profileTitle}>
                            Apellido(s):
                        </div>
                        <div className={style.textDiv}>
                            <p className={style.profileText}>{user.userLastName}</p>
                        </div>
                        
                        <div className={style.profileTitle}>
                            Tipo de documento:
                        </div>
                        <div className={style.textDiv}>
                            <p className={style.profileText}>{documentTypes[user.documentTypeId - 1]}</p>
                        </div>

                        <div className={style.profileTitle}>
                            Numero de documento:
                        </div>
                        <div className={style.textDiv}>
                            <p className={style.profileText}>{user.userDocumentNumber}</p>
                        </div>

                        <div className={style.profileTitle}>
                            Fecha de expedición:
                        </div>
                        <div className={style.textDiv}>
                            <p className={style.profileText}>{user.userDocumentExpeditionDate}</p>
                        </div>

                        <div className={style.profileTitle}>
                            Correo electrónico:
                        </div>
                        <div className={style.textDiv}>
                            <p className={style.profileText}>{user.userEmail}</p>
                        </div>

                        <div className={style.profileTitle}>
                            Telefono:
                        </div>
                        <div className={style.textDiv}>
                            <p className={style.profileText}>{user.userPhone}</p>
                        </div>
                    </div>
                    <div className='flex w-full sm:w-[50%] mt-4 mx-auto'>
                        <ControlButtonAdd onClick={()=>setIsModalProfileUpdateOpen(true)} text="EDITAR PERFIL" />
                    </div>
                </div>
            </div>

        </>
    )
}

export default Profile